<template>
  <div id="app" :style="{background: backgroundColorDanjuan ? '#EF4B40' : backgroundColorTencentwm ? '#3662ec' : '#efeff1'}">
    <keep-alive>
      <router-view v-if="$route.meta.keepalive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepalive" />
      <!-- <router-view/> -->
  </div>
</template>

<script>
import {MessageBox} from 'mint-ui'
import {WEB_USER_TOKEN, WEB_DEVICE_ID, WORK_WEIXIN_USER_TEMPTOKEN} from './constants/LocalStorageKey'
import CordovaUtils from './components/utils/CordovaUtils'
import wx from 'weixin-js-sdk'
import ajax from './apis/ajax'
export default {
  name: 'App',
  data () {
    return {
      deviceId: ''
    }
  },
  computed: {
    backgroundColorDanjuan () {
      return this.$route.path === '/vote/endOfVotingXueqiu'
    },
    backgroundColorTencentwm () {
      return this.$route.path === '/vote/endOfVotingLicaitong'
    }
  },
  created () {
    sessionStorage.setItem('wxConfigFlag', 'false')
    if (this.$route.meta.title) {
      document.title = this.$route.meta.title
    }
    let deviceId = CordovaUtils.getQueryParamValue(WEB_DEVICE_ID)
    if (deviceId !== null) {
      this.axios.globalDeviceId = deviceId
    }
    this.deviceId = this.axios.globalDeviceId
    let workWeixinUserTempToken = CordovaUtils.getQueryParamValue(WORK_WEIXIN_USER_TEMPTOKEN)
    console.log('%c 这是显示的地方', 'font-size: 18px; color: red;', this.deviceId, this.axios.globalDeviceId)
    if (workWeixinUserTempToken != null) {
      ajax.synPost('api/login/authLogin', {
        tempLoginToken: workWeixinUserTempToken,
        deviceId: this.axios.globalDeviceId
      }, this.initWorkWeixinLogin)
    } else {
      let userToken = CordovaUtils.getQueryParamValue(WEB_USER_TOKEN)
      console.log('-> userToken', userToken)
      if (userToken !== null) {
        this.axios.globalToken = userToken
      }
      this.axios.get(`api/dicts/refresh`).then(res => {})
      ajax.synGet('/api/dicts/queryAll', {
        deviceId: this.deviceId
      }, this.initDictionaries)
    }
    this.$router.beforeEach(this.routerGuard)

    this.configWxJsapi()
  },
  mounted () {
    if (this.$route.meta.title) {
      document.title = this.$route.meta.title
    }
  },
  beforeUpdate () {
  },
  methods: {
    goCheckSession () {
      this.axios.get('/api/auth/check').then(this.checkSession)
    },
    checkSession (response) {
      if (response.data) {
        if (response.data.errorCode === 401) {
        } else {
          this.axios.get('/api/systemService/queryPageServiceListWithAuthResult').then(this.initServerApis)
        }
      }
    },
    initWorkWeixinLogin (res) {
      if (res.errorCode === 0) {
        sessionStorage.setItem('userId', res.data.userId)
        sessionStorage.setItem('userType', res.data.userType) // 1微信用户, 2渠道用户, 3管理用户
        sessionStorage.setItem('channelUserStatus', res.data.channelUserStatus) // 用户账号状态 1-正常；2-已禁用；3-已注销
        localStorage.setItem(WEB_USER_TOKEN, res.data.loginToken)
        this.axios.globalToken = res.data.loginToken
        console.log(this.deviceId)
        ajax.synGet('/api/dicts/queryAll', {
          deviceId: this.deviceId
        }, this.initDictionaries)
        this.axios.get('/api/systemService/queryPageServiceListWithAuthResult').then(this.initServerApis)
      } else {
        this.$router.replace({
          name: 'LoginFail'
        })
      }
    },
    getRouter () {
      if (Number(sessionStorage.getItem('channelUserStatus')) === 2) {
        this.$router.replace({
          path: 'disabled'
        })
        return
      }
      let url = window.location.hash.substring(1, window.location.hash.indexOf('?'))
      let urlApis = this.$store.state.serverApis.urlApis
      let api = urlApis[url]
      if (api && api.serviceLevel === 3) {
        if (Number(sessionStorage.getItem('userType')) === 1) {
          sessionStorage.setItem('fullPath', window.location.hash.substring(1))
          document.title = '鹏扬基金渠道服务'
          this.$router.replace({
            path: '/'
          })
        }
      }
    },
    initDictionaries (response) {
      this.$store.commit('dictionary/setDictionaries', response)
    },
    initServerApis (response) {
      this.$store.commit('serverApis/initServerApis', response.data)
      this.getRouter()
    },
    routerGuard (to, from, next) {
      // console.log('%c to', 'font-size: 18px; color: green;', to, to.path)
      let url = to.path
      // 查询url是否是定义的页面服务
      let urlApis = this.$store.state.serverApis.urlApis
      // console.log('%c urlApis', 'font-size: 18px; color: yellow;', urlApis)
      let regexApis = this.$store.state.serverApis.regexApis
      let api = urlApis[url]
      // console.log('%c api', 'font-size: 18px; color: yellow;', api)
      if (!api) {
        url = url.replace(':', '')
        for (let index in regexApis) {
          let regexApi = regexApis[index]
          if (regexApi.pattern.test(url)) {
            api = regexApi
            break
          }
        }
      }
      let permit = false
      if (api) {
        if (api.serviceLevel === 0) {
          permit = true
        } else if (api.serviceLevel === 1 || api.serviceLevel === 3) {
          permit = true
        } else if (api.serviceLevel === 2) {
          permit = api.authResult === 1
        }
      } else {
        permit = true
      }
      if (api && api.serviceLevel === 3) {
        if (Number(sessionStorage.getItem('userType')) === 1) {
          sessionStorage.setItem('fullPath', to.fullPath)
          next({path: '/'})
        }
      }
      if (permit) {
        if (to.meta.title) {
          document.title = to.meta.title
        } else {
          document.title = '鹏扬基金渠道服务'
        }
        next()
      } else {
        MessageBox.alert('没有操作权限', '错误提示')
      }
    },
    logout () {
      this.$confirm('确定退出登录吗?', {
        confirmButtonClass: 'confirmButton',
        cancelButtonClass: 'btn-custom-cancel',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.clear()
        this.axios.globalToken = null
        this.axios.post('/api/login/logout', {}).then(() => {
          // localStorage.clear()
          try {
            if (window.plugins && window.plugins.NativeStorage) {
              window.plugins.NativeStorage.removeItem(WEB_USER_TOKEN)
            } else {
              console.info('---- no native storage plugin-----')
            }
          } catch (e) {
            console.log('native storage error' + e)
          }
          this.$router.push({
            name: 'Login'
          })
        })
        // this.$router.push({
        //   name: 'Login'
        // })
      })
      // this.axios.post('api/login/logout').then(res => {
      //   console.log('退出了', res)
      // })
    },
    configWxJsapi () {
      let url = window.location.href
      if (url.indexOf('#') > 0) {
        url = url.substring(0, url.indexOf('#'))
      }
      wx.ready(() => {
        console.log('weixin js api ready')
        sessionStorage.setItem('wxConfigFlag', 'true')
        wx.checkJsApi({
          jsApiList: ['updateAppMessageShareData'], // 需要检测的 JS 接口列表，所有 JS 接口列表见附录2,
          success: function (res) {
            // 以键值对的形式返回，可用的 api 值true，不可用为false
            console.log(res)
          }
        })
      })
      wx.error((res) => {
        console.error('weixin js api error:' + res.errMsg)
      })
      this.axios.post('/api/weixinmp/jsapiUrlConfig', {
        url: url
      }).then((res) => {
        if (!res) return
        let configData = res.data.data
        configData.jsApiList.push('updateAppMessageShareData')
        configData.jsApiList.push('updateTimelineShareData')
        configData.jsApiList.push('getLocalImgData')
        console.log('config Data:' + JSON.stringify(configData))
        if (configData) {
          wx.config(configData)
        }
      })
    }
  }
}
</script>

<style lang="scss">
  @import '../node_modules/mint-ui/lib/style.css';
  @import "assets/css/border.css";
  @import "/assets/scss/theme/customized_mintui";
  @import '/assets/scss/global';
  @import "/assets/scss/theme/_default_variables";
* {
  padding: 0;
  margin: 0;
  outline: none;
}
// 清除 a 链接默认样式
a {
  text-decoration: none;
}
a:link {
  text-decoration: none;
}
a:visited {
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}
a:active {
  text-decoration: none;
}
body {
  background-color: #efeff1;
  // 文本不能被选中
  /*-moz-user-select:none;!*火狐*!
  -webkit-user-select:none;!*webkit浏览器*!
  -ms-user-select:none;!*IE10*!
  user-select:none;*/
}
body {
  font-family: '微软雅黑';
}
  li {
    list-style: none;
  }
  /*未读标记badge*/
  .el-badge__content.is-fixed{
    top:3px;
    right:0!important;
  }
  .cancelButton {
    float: right;
    margin-left: 10px;
  }
  /*.el-badge__content.is-fixed{
    top:12px;
    right:-3px;
  }
  .el-badge__content{
    font-size:10px;
    width:14px;
    height: 14px;
    line-height: 14px;
    padding: 0;
    border-radius: 50%;
    border: 0;
  }
  .el-badge__content.is-dot{
    width:8px;
    height:8px;
  }*/
html, body, #app {
  width: 100%;
  // height: 100%;
}
.press-vote:active {
    background: #F7534626 !important;
    -webkit-tap-highlight-color: #F7534626 !important;
    // opacity: 0.15;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue